import EntityChallengeSwitchCard from './EntityChallengeSwitchCard';

export default EntityChallengeSwitchCard;
